import BeelineLanding from '../beelineLp/BeelineLanding';

export default function Beeline1() {
  return <BeelineLanding lpKey="beeline1" lpName="KG Beeline 1 LP" variant={1} />;
}
